import React, { useState } from 'react';
import { Button, ButtonProps,} from 'antd';
import { SearchOutlined, DownloadOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

interface ReusableButtonProps extends ButtonProps {
}

// Primary Button
export const PrimaryButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'primary',
  style,
  ...props

}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#1677ff': '#1677ff',
        color:hovered ?'#fff' :'#fff',
        border: 'none',
        borderRight:'none',
        padding: '0 10px',
        margin: '5px',
        borderRadius: '15px 0 0 15px  ', 
        marginRight:0,  
       transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
       transition: 'all 0.2s ease',
       width: hovered ? '135px' : '95px',
      ...style,
        ...style
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

//Animate button

export const AnimateButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'primary',
  style,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);
  const [clicked, setClicked] = useState(false);

  return (
    <Button
      className='animate-button'
      type={type}
      onClick={(e) => {
        setClicked(true);
        setTimeout(() => setClicked(false), 150); // Reset animation after 150ms
        if (onClick) onClick(e); // Trigger the provided onClick handler
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#1677ff': '#1677ff',
        color:hovered ?'#fff' :'#fff',
        border: 'none',
        borderRadius: '8px',
        padding: '0 20px',
        transition: 'all 0.2s ease', 
        marginRight: '16px',
        transform: clicked
          ? 'scale(0.95)' 
          : hovered
          ? 'scale(1.06)' 
          : 'scale(1)', 
        boxShadow: hovered
          ? '0 4px 10px rgba(0, 0, 0, 0.3)' // Shadow on hover
          : clicked
          ? '0 2px 5px rgba(0, 0, 0, 0.2)' // Slight shadow on click
          : '0 2px 5px rgba(0, 0, 0, 0.1)', // Default shadow
          ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

// Secondary Button
export const SecondaryButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'default',
  style,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#0958d9' : 'transparent', // Light blue on hover, light gray default
        color: hovered ? '#fff' : '#003a8c',
        border: '1px solid #003a8c',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

// Dashed Button
export const DashedButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'dashed',
  style,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#e6f7ff' : 'transparent', // Slight background on hover
        color: '#003a8c',
        border: '1px dashed #003a8c',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

// Text Button
export const TextButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'text',
  style,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#e6f7ff' : 'transparent', // Light blue on hover
        color: hovered ? '#1890ff' : '#1890ff',
        border: 'none',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
      
    >
      {children}
    </Button>
  );
};

// Link Button
export const LinkButton: React.FC<ReusableButtonProps> = ({
  children,
  onClick,
  type = 'link',
  style,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: 'transparent',
        color: hovered ? '#40a9ff' : '#1890ff', // Brighter blue on hover
        textDecoration: hovered ? 'underline' : 'none',
        border: 'none',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
     
    >
      {children}
    </Button>
  );
};


// Default Button
export const DefaultButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    type = 'default',
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
  
    return (
      <Button
        type={type}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? 'transparent' : '#f0f0f0',
          color: hovered ? '#003a8c' : '#000',
          border: hovered ? '1px solid #003a8c' : '1px solid #d9d9d9',
          borderRadius: '8px',
          padding: '0 20px',
          margin: '5px',
          ...style,
        }}
        {...props}
        
      >
        {children}
      </Button>
    );
  };
  
  // Search Button
  export const SearchButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
      type="primary"
    //   icon={<SearchOutlined />}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#fff' : '#0958d9',
        color: hovered ? '#40a9ff' : '#fff',
        border: '1px solid #40a9ff',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
      
    >
      {children}
      <SearchOutlined />
    </Button>

    );
  }

  // Default Search Button
  export const DefaultSearchButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
      type="primary"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? 'transparent' : 'transparent',
        color: hovered ? '#40a9ff' : 'black',
        border: hovered ? '1px solid #40a9ff' : '1px solid #ccc',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
      
    >
      {children}
      <SearchOutlined />

    </Button>

    );
  }
    
  // Search Button with Icon Only
  export const SearchButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<SearchOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? 'transparent' : '#0958d9',
          color: hovered ? '#0958d9' : '#fff',
          border: hovered ? '1px solid #0958d9' : 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style,
        }}
        {...props}
      />
    );
  }
  // Edit Button with Icon Only
  export const EditButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? 'transparent' : '#0958d9',
          color: hovered ? '#0958d9' : '#fff',
          border: hovered ? '1px solid #0958d9' : 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style,
        }}
        {...props}
      />
    );
  }

  
  // Action Button
  export const ActionButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => (
    <Button
      type="dashed"
      onClick={onClick}
      style={{
        backgroundColor: '#fafafa',
        color: '#000',
        border: '1px dashed #d9d9d9',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '0px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
  
  // Download Button
  export const DownloadButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#fff' : '#0958d9',
        color: hovered ? '#40a9ff' : '#fff',
        border: '1px solid #40a9ff',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );}

  // Default Download Button
  export const DeafaultDownloadButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? 'transparent' : 'transparent',
        color: hovered ? '#40a9ff' : 'black',
        border: hovered ? '1px solid #40a9ff' : '1px solid #ccc',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );}


  
  // Download Button with Icon Only
  export const DownloadButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
}) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? 'transparent' : '#0958d9',
          color: hovered ? '#0958d9' : '#fff',
          border: hovered ? '1px solid #0958d9' : 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style,
        }}
        {...props}
      />
    );
  }

  export const SecondaryDownloadButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
}) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? '#0958d9':'transparent',
          color: hovered ? '#fff' : '#0958d9',
          border: hovered ? 'none' : '1px solid #0958d9',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style
        }}
        {...props}
      />
    );
  }
  export const SecondaryEditButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
}) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? '#0958d9':'transparent',
          color: hovered ? '#fff' : '#0958d9',
          border: hovered ? 'none' : '1px solid #0958d9',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style,
        }}
        {...props}
      />
    );
  }
  
  // Download Button with Icon Only
  export const DeleteButtonIcon: React.FC<ReusableButtonProps> = ({
    onClick,
    style,
    ...props
}) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
        type="primary"
        icon={<DeleteOutlined />}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          backgroundColor: hovered ? 'transparent' : '#ff4d4f',
          color: hovered ? '#ff4d4f' : '#fff',
          border: hovered ? '1px solid #ff4d4f' : 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px',
          ...style,
        }}
        {...props}
      />
    );
  }
  
  // Gradient Button
  export const GradientButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
    <Button
      type="primary"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundImage: hovered ? 'linear-gradient(to right, #2575fc, #6a11cb)' : 'linear-gradient(to right, #6a11cb, #2575fc)',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
      }}
      {...props}
    >
      {children}
    </Button>
  );}
  
  // Red Button
  export const DeleteButton: React.FC<ReusableButtonProps> = ({
    children,
    onClick,
    style,
    ...props
  }) => {
    const [hovered, setHovered] = useState(false);
    return(
        <Button
      type="primary"
      danger
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? '#ff4d4f':'transparent',
        color: hovered ? '#fff' : '#ff4d4f',
        border: hovered ? 'none' : '1px solid #ff4d4f',
        borderRadius: '8px',
        padding: '0 20px',
        margin: '5px',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
    );
  }



